/**
 * @author: Angel Labrada
 * @date: 9/7/22
 */
import React, {memo, useCallback} from 'react';
import PropTypes from 'prop-types';
import SelectElementCmp from '@/utils/SelectElementCmp';
import NomenclaturesAreaTypeApiService from '@/modules/settings/services/NomenclaturesAreaTypeApiService';

const SelectFacilityType = ({value, onChange, setRegisterType, form, ...props}) => {

  const handleOnChange = useCallback((val) => {
    onChange(val);
    setRegisterType(val);
    form.setFieldsValue({areas: []});
  }, [form, onChange, setRegisterType]);

  return (
    <SelectElementCmp
      queryKey={'register-facility-select'}
      service={NomenclaturesAreaTypeApiService}
      includeValue={''}
      value={typeof value === 'object' ? value?._id : value}
      onChange={handleOnChange}
      sort={{ code: 1 }}
      queryConfig={{ refetchOnWindowFocus: false }}
      className="custom-select"
      {...props}
      filters={null}
    />
  );
};

SelectFacilityType.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  setRegisterType: PropTypes.func,
  form: PropTypes.object,
};


export default memo(SelectFacilityType);
